import React from "react";

export function Card({
	className = "",
	...props
}: React.HTMLAttributes<HTMLDivElement>) {
	return <div className={`card ${className}`} {...props} />;
}

export function CardHeader({
	className = "",
	...props
}: React.HTMLAttributes<HTMLDivElement>) {
	return <div className={`p-5 pb-0 ${className}`} {...props} />;
}

export function CardContent({
	className = "",
	...props
}: React.HTMLAttributes<HTMLDivElement>) {
	return <div className={`p-5 ${className}`} {...props} />;
}

export function CardFooter({
	className = "",
	...props
}: React.HTMLAttributes<HTMLDivElement>) {
	return <div className={`p-5 pt-0 ${className}`} {...props} />;
}
